import PropTypes from 'prop-types';
import { Component } from 'react';
// @ts-expect-error untyped module customer-data-objects-ui-components
import ObjectTypeIdType from 'customer-data-objects-ui-components/propTypes/ObjectTypeIdType';
import ClassicNotificationEmailActionMetadata from 'automation-ui-action-features/actions/classic-notification-email/records/ClassicNotificationEmailActionMetadata';
import LogEventRowAction from 'automation-ui-action-features/components/LogEventRowAction';
import ClassicNotificationEmailActionDetail from 'automation-ui-action-features/actions/classic-notification-email/ClassicNotificationEmailActionDetail';
import { jsx as _jsx } from "react/jsx-runtime";
class ClassicNotificationEmailActionHistoryCard extends Component {
  render() {
    const {
      actionMetadata,
      flowObjectTypeId,
      actionLabel
    } = this.props;
    return /*#__PURE__*/_jsx(LogEventRowAction, {
      title: actionLabel,
      content: /*#__PURE__*/_jsx(ClassicNotificationEmailActionDetail, {
        actionMetadata: actionMetadata,
        flowObjectTypeId: flowObjectTypeId
      })
    });
  }
}
ClassicNotificationEmailActionHistoryCard.propTypes = {
  actionMetadata: PropTypes.instanceOf(ClassicNotificationEmailActionMetadata).isRequired,
  actionLabel: PropTypes.node,
  flowObjectTypeId: ObjectTypeIdType
};
export default ClassicNotificationEmailActionHistoryCard;